// import "@fullcalendar/core/vdom"; // solve problem with Vite
import FullCalendar from "@fullcalendar/vue3";



export default defineNuxtPlugin((/* nuxtApp */) => {
  return {
    provide: {
      fullCalendar: FullCalendar,
    },
  };
});
